// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lHMmhb {
  display: inline-block;
  cursor: pointer;
  font-size: 0;
}

.BEj3QO {
  position: fixed;
  min-width: 60px;
  width: max-content;
  background-color: var(--on-surface-neutral-stronger, #666666);
  color: var(--text-neutral-white, #ffffff);
  border-radius: var(--radius-s, 4px);
  padding: var(--spacing-1, 8px) var(--spacing-2, 16px);
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-sm, 12px);
  font-weight: var(--font-weight-regular, 400);
  line-height: 1.4;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  word-wrap: break-word;
  overflow-wrap: break-word;
  animation: SQNSm0 0.2s ease-in-out;
  box-sizing: border-box;
}

.BEj3QO[style*='opacity: 0.01'] {
  animation: none;
  transition: none;
  pointer-events: none;
}

.ViFASm {
  position: relative;
  z-index: 1;
  text-align: center;
  white-space: pre-line;
}

.UFy6PM {
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
}

.BEj3QO.d2_Lc7 .UFy6PM {
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 8px 8px 0 8px;
  border-color: var(--on-surface-neutral-stronger, #666666) transparent transparent transparent;
}

.BEj3QO.qmQqhw .UFy6PM {
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 0 8px 8px 8px;
  border-color: transparent transparent var(--on-surface-neutral-stronger, #666666) transparent;
}

.BEj3QO.ygmSBp .UFy6PM {
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  border-width: 8px 0 8px 8px;
  border-color: transparent transparent transparent var(--on-surface-neutral-stronger, #666666);
}

.BEj3QO.wTakgE .UFy6PM {
  left: -8px;
  top: 50%;
  transform: translateY(-50%);
  border-width: 8px 8px 8px 0;
  border-color: transparent var(--on-surface-neutral-stronger, #666666) transparent transparent;
}

@keyframes SQNSm0 {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (max-width: 768px) {
  .BEj3QO {
    min-width: 50px;
    font-size: var(--font-size-xs, 11px);
    padding: var(--spacing-0-5, 4px) var(--spacing-0-75, 6px);
    line-height: 1.3;
  }
}

@media (max-width: 480px) {
  .BEj3QO {
    min-width: 40px;
    font-size: 10px;
    padding: 3px 5px;
    line-height: 1.2;
  }
}

@media (prefers-contrast: high) {
  .BEj3QO {
    border: 1px solid var(--text-neutral-white, #ffffff);
  }
}

@media (prefers-reduced-motion: reduce) {
  .BEj3QO {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Tooltip/Tooltip.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,6DAA6D;EAC7D,yCAAyC;EACzC,mCAAmC;EACnC,qDAAqD;EACrD,iEAAiE;EACjE,oCAAoC;EACpC,4CAA4C;EAC5C,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,2BAA2B;EAC3B,6FAA6F;AAC/F;;AAEA;EACE,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,2BAA2B;EAC3B,6FAA6F;AAC/F;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,2BAA2B;EAC3B,6FAA6F;AAC/F;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,2BAA2B;EAC3B,6FAA6F;AAC/F;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;IACf,oCAAoC;IACpC,yDAAyD;IACzD,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".trigger {\n  display: inline-block;\n  cursor: pointer;\n  font-size: 0;\n}\n\n.tooltip {\n  position: fixed;\n  min-width: 60px;\n  width: max-content;\n  background-color: var(--on-surface-neutral-stronger, #666666);\n  color: var(--text-neutral-white, #ffffff);\n  border-radius: var(--radius-s, 4px);\n  padding: var(--spacing-1, 8px) var(--spacing-2, 16px);\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-sm, 12px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 1.4;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 9999;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  animation: fadeIn 0.2s ease-in-out;\n  box-sizing: border-box;\n}\n\n.tooltip[style*='opacity: 0.01'] {\n  animation: none;\n  transition: none;\n  pointer-events: none;\n}\n\n.content {\n  position: relative;\n  z-index: 1;\n  text-align: center;\n  white-space: pre-line;\n}\n\n.arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n}\n\n.tooltip.top .arrow {\n  bottom: -8px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 8px 8px 0 8px;\n  border-color: var(--on-surface-neutral-stronger, #666666) transparent transparent transparent;\n}\n\n.tooltip.bottom .arrow {\n  top: -8px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 0 8px 8px 8px;\n  border-color: transparent transparent var(--on-surface-neutral-stronger, #666666) transparent;\n}\n\n.tooltip.left .arrow {\n  right: -8px;\n  top: 50%;\n  transform: translateY(-50%);\n  border-width: 8px 0 8px 8px;\n  border-color: transparent transparent transparent var(--on-surface-neutral-stronger, #666666);\n}\n\n.tooltip.right .arrow {\n  left: -8px;\n  top: 50%;\n  transform: translateY(-50%);\n  border-width: 8px 8px 8px 0;\n  border-color: transparent var(--on-surface-neutral-stronger, #666666) transparent transparent;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@media (max-width: 768px) {\n  .tooltip {\n    min-width: 50px;\n    font-size: var(--font-size-xs, 11px);\n    padding: var(--spacing-0-5, 4px) var(--spacing-0-75, 6px);\n    line-height: 1.3;\n  }\n}\n\n@media (max-width: 480px) {\n  .tooltip {\n    min-width: 40px;\n    font-size: 10px;\n    padding: 3px 5px;\n    line-height: 1.2;\n  }\n}\n\n@media (prefers-contrast: high) {\n  .tooltip {\n    border: 1px solid var(--text-neutral-white, #ffffff);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .tooltip {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `lHMmhb`,
	"tooltip": `BEj3QO`,
	"fadeIn": `SQNSm0`,
	"content": `ViFASm`,
	"arrow": `UFy6PM`,
	"top": `d2_Lc7`,
	"bottom": `qmQqhw`,
	"left": `ygmSBp`,
	"right": `wTakgE`
};
module.exports = ___CSS_LOADER_EXPORT___;
